import { useEffect, useRef, useState } from 'react';

import formStartImageBlack from '../assets/images/form-start-image-black.png';
import formStartImageWhite from '../assets/images/form-start-image-white.png';

interface Props {
  design?: any;
  url: string;
}

const determineImage = (hexCode: string) => {
  // old color data sometimes have 3 hexcode string for black or white
  // may need to remove (deprecate) this if block once things settle
  if (hexCode === 'FFF' || hexCode === 'FFFFFF') {
    return formStartImageBlack;
  } else if (hexCode === '000' || hexCode === '000000') {
    return formStartImageWhite;
  }

  // https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
  const red = parseInt(hexCode.substring(0, 2), 16);
  const green = parseInt(hexCode.substring(2, 4), 16);
  const blue = parseInt(hexCode.substring(4, 6), 16);
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186
    ? formStartImageBlack
    : formStartImageWhite;
};

export const StartImage: React.FC<Props> = (props) => {
  const [imageClass, setImageClass] = useState(
    'form-start-page-image-landscape'
  );
  const ref: any = useRef(null);
  useEffect(() => {
    const width = ref.current!.naturalWidth;
    const height = ref.current!.naturalHeight;
    const ratio = height / width;
    if (ratio >= 0.8) {
      setImageClass('form-start-page-image-portrait');
    }
  }, []);

  const imageURL =
    props.url === ''
      ? determineImage(
          props.design.colors.background.toUpperCase().substring(1) // substring(1) to get rid of pound sign in hexcode
        )
      : props.url;

  return (
    <div style={{ justifyContent: 'center', alignItems: 'center' }}>
      <img
        className={imageClass}
        src={imageURL}
        ref={ref}
        alt={'form-start-page-image'}
      />
    </div>
  );
};
